import { createContext, useContext } from "react";

export type BoardContext = {
    isArchived: boolean;
};

export const MyBoardContext = createContext<BoardContext>({
    isArchived: false,
});
export const useBoardContext = () => useContext(MyBoardContext);
